<template>
  <section class="contact-page">
    <transition name="fade" appear>
      <h2>Social Media</h2>
    </transition>

    <div class="social-icons">
      <a
        href="https://www.youtube.com/@NightKillOfficial"
        target="_blank"
        aria-label="YouTube"
        class="load-hidden"
      >
        <i class="fab fa-youtube"></i>
      </a>
      <a
        href="https://www.facebook.com/profile.php?id=61553917104417"
        target="_blank"
        aria-label="Facebook"
        class="load-hidden"
      >
        <i class="fab fa-facebook"></i>
      </a>
      <a
        href="https://www.instagram.com/nightkill_band_official/"
        target="_blank"
        aria-label="Instagram"
        class="load-hidden"
      >
        <i class="fab fa-instagram"></i>
      </a>
    </div>

    <div class="contact-info load-hidden">
      <p>📧 You can reach out to us at:</p>
      <p class="email">nightkillband2023@gmail.com</p>
    </div>
  </section>
</template>

<script>
import { useHead } from '@vueuse/head';
import ScrollReveal from 'scrollreveal';
import '@fortawesome/fontawesome-free/css/all.min.css';

export default {
  name: 'ContactView',
  mounted() {
    useHead({
      title: 'Contact | Nightkill Official',
      meta: [
        {
          name: 'description',
          content:
            'Reach out to Nightkill — melodic heavy metal from Greece. For bookings, fan messages, press, or collaborations.',
        },
        {
          name: 'keywords',
          content:
            'Nightkill contact, metal band Greece, booking, press email, fan messages, heavy metal band',
        },
        { property: 'og:title', content: 'Contact | Nightkill Official' },
        {
          property: 'og:description',
          content:
            'Get in touch with Nightkill — Greek melodic metal band. Booking, press, and fan messages welcome.',
        },
        {
          property: 'og:image',
          content: 'https://nightkill.gr/metadata/nightkill-logo.png',
        },
        { property: 'og:url', content: 'https://nightkill.gr/contact' },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'Nightkill Official' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Contact | Nightkill Official' },
        {
          name: 'twitter:description',
          content:
            'Connect with Nightkill — melodic heavy metal from Greece. Booking, press, social links, and fan shoutouts.',
        },
        {
          name: 'twitter:image',
          content: 'https://nightkill.gr/metadata/nightkill-logo.png',
        },
      ],
      link: [{ rel: 'canonical', href: 'https://nightkill.gr/contact' }],
    });

    this.$nextTick(() => {
      setTimeout(() => {
        const sr = ScrollReveal({
          distance: '30px',
          origin: 'bottom',
          opacity: 0,
          duration: 600,
          easing: 'ease-in-out',
          cleanup: true,
        });

        sr.reveal('.social-icons a', {
          interval: 200,
        });

        sr.reveal('.contact-info p', {
          delay: 500,
          interval: 350,
        });
      }, 100);
    });
  },
  beforeUnmount() {
    ScrollReveal().destroy();
  },
};
</script>

<style scoped>
.contact-page {
  text-align: center;
  padding: 0 1rem;
}

h2 {
  color: #2c3e50;
  margin-bottom: 2rem;
  font-size: 2.5rem;
  margin-top: 0;
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 2rem;
  font-size: 2.5rem;
  margin-bottom: 2rem;
}

/* Default icon colors */
.social-icons a[aria-label='YouTube'] {
  color: #b82525;
}

.social-icons a[aria-label='Facebook'] {
  color: #2369c5;
}

.social-icons a[aria-label='Instagram'] {
  color: #c24159;
}

/* Hover effect: NightKill color + glow */
.social-icons a:hover {
  color: #d0a85c;
  transform: scale(1.15);
  text-shadow: 0 0 6px rgba(208, 168, 92, 0.6);
  transition: color 0.3s ease, transform 0.3s ease, text-shadow 0.3s ease;
}

.contact-info {
  padding-top: 3rem;
  font-size: 1.2rem;
  color: #ccc;
}

.email {
  font-weight: 700;
  color: #909078;
  font-size: 1.25rem;
}

/* CSS for the fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
